import config from "config/config"
import axios from "axios"
import * as url from "../helpers/url_helper"

export const feePaymentApi = {
  getFeePaymentList: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.GET_FEE_PAYMENT_LIST}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }
    return await axios(axiosConfig)
  },

  exportFeePaymentReport: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.EXPORT_FEE_PAYMENT_REPORT}`,
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
      data,
    }
    return await axios(axiosConfig)
  },

  markFeePaymentPaid: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.MARK_FEE_PAYMENT}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }
    return await axios(axiosConfig)
  },
}

